import { SetStateAction } from 'react';
import { SortableListProvider } from '@/components/listItem/SortableListProvider';
import { toggleValue } from '@/utils/array';
import { SortableItem } from './SortableItem';

export const SortableContent = ({
  visibleColumns,
  setVisibleColumns,
  lockedColumns = [],
}: {
  visibleColumns: string[];
  setVisibleColumns: (value: SetStateAction<string[]>) => void;
  lockedColumns?: string[];
}) => {
  const toggleColumn = (columnKey: string) => setVisibleColumns(toggleValue(columnKey, visibleColumns));

  return (
    <SortableListProvider values={visibleColumns} setValues={setVisibleColumns}>
      <ul className="flex flex-col gap-2 overflow-hidden px-4 pb-4 pt-0.5">
        {visibleColumns.map(column => (
          <SortableItem
            key={column}
            id={column}
            toggleColumn={toggleColumn}
            isLocked={lockedColumns.includes(column)}
          />
        ))}
      </ul>
    </SortableListProvider>
  );
};
